var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Select } from '@blueprintjs/select';
import { MenuItem, Button, Icon } from '@blueprintjs/core';
var RemoteSelect = /** @class */ (function (_super) {
    __extends(RemoteSelect, _super);
    function RemoteSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Select = Select.ofType();
        _this.state = {
            items: [],
            query: ''
        };
        _this.propFetch = function (query) { return __awaiter(_this, void 0, void 0, function () {
            var items;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.fetch) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.props.fetch(query)];
                    case 1:
                        items = _a.sent();
                        this.setState({ items: items });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.localFetch = function (_query) { return __awaiter(_this, void 0, void 0, function () {
            var Klass, resource, query, CancelToken, response, items, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.klass) {
                            console.error('[RemoteSelect] unable to perform localFetch, klass prop not specified');
                            return [2 /*return*/];
                        }
                        if (!this.props.axios) {
                            console.error('[RemoteSelect] unable to perform localFetch, axios prop not specified');
                            return [2 /*return*/];
                        }
                        Klass = this.props.klass;
                        resource = Klass.resource;
                        if (!resource || resource.length === 0) {
                            console.error('[RemoteSelect] unable to perform localFetch, resource is not set');
                            return [2 /*return*/];
                        }
                        query = _query.trim().toLowerCase();
                        if (this.cancelToken) {
                            this.cancelToken();
                        }
                        CancelToken = this.props.axios.CancelToken;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.axios.get("/" + resource + "/search?query=" + query, {
                                cancelToken: new CancelToken(function (token) {
                                    _this.cancelToken = token;
                                })
                            })];
                    case 2:
                        response = _a.sent();
                        items = response.data[resource].map(function (i) { return new Klass(i); });
                        this.setState({ items: items });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        if (!this.props.axios.isCancel(e_1)) {
                            throw e_1;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.onQueryChange = function (query) {
            _this.setState({ query: query });
            if (_this.props.fetch) {
                _this.propFetch(query);
                return;
            }
            if (_this.props.klass) {
                _this.localFetch(query);
                return;
            }
        };
        _this.cancel = function () {
            if (!_this.props.klass) {
                return;
            }
            var Klass = _this.props.klass;
            _this.props.onSelect(new Klass({}));
        };
        _this.itemRenderer = function (item, options) { return React.createElement(MenuItem, { key: "remote-select-item-" + item.id, text: item.getTitle(), label: item.getLabel() || '', onClick: options.handleClick }); };
        return _this;
    }
    RemoteSelect.prototype.componentDidMount = function () {
        this.onQueryChange('');
    };
    RemoteSelect.ofType = function () {
        return RemoteSelect;
    };
    RemoteSelect.prototype.render = function () {
        var BlueprintSelect = this.Select;
        var hint = this.props.hint || 'Select';
        var activeItem = this.props.activeItem;
        var text = activeItem.exists ? activeItem.getTitle() : hint;
        return (React.createElement(BlueprintSelect, { activeItem: this.props.activeItem, items: this.state.items, itemRenderer: this.itemRenderer, onItemSelect: this.props.onSelect, query: this.state.query, onQueryChange: this.onQueryChange },
            React.createElement(Button, { outlined: this.props.outlined, minimal: this.props.minimal, fill: this.props.fill, icon: this.props.cancelable && this.props.activeItem.exists ? 'chevron-down' : this.props.icon, 
                // rightIcon="chevron-down"
                rightIcon: (this.props.cancelable && this.props.activeItem.exists) ?
                    React.createElement(Icon, { icon: "cross", intent: "warning", onClick: this.cancel }) :
                    React.createElement(Icon, { icon: "chevron-down", intent: this.props.intent || (this.props.activeItem.exists ? 'primary' : 'none') }), text: text, intent: this.props.activeItem.exists ? 'success' : (this.props.intent || 'none') })));
    };
    return RemoteSelect;
}(React.Component));
export { RemoteSelect };
//# sourceMappingURL=remote-select.js.map